import React from "react";
import PropTypes from "prop-types";
import { footerUrls } from "../../../constants";

function finePrintLinks(props) {
  return (
    <div className="nw-fineprint-container">
      <a className="nw-fineprint-links" href="/">
        © 2018 NNNOW
      </a>
      <a
        className="nw-fineprint-links"
        href={props.store.basePath + footerUrls.privacypolicy}
      >
        Privacy Policy
      </a>
      <a
        className="nw-fineprint-links"
        href={props.store.basePath + footerUrls.termsconditions}
      >
        Terms & Conditions
      </a>
    </div>
  );
}

finePrintLinks.propTypes = {
  store: PropTypes.shape({
    basePath: PropTypes.string.isRequired,
  }).isRequired,
};

export default finePrintLinks;



// WEBPACK FOOTER //
// ./src/component/Footer/FinePrintLinks/index.js